class MediaGalleryVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.mediaGallery = this.closest('media-gallery');
    this.slideshow = this.mediaGallery?.querySelector('slideshow-component');
    this.radioButtons = this.querySelectorAll('input[type="radio"]');
    
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.radioButtons.forEach(radio => {
      radio.addEventListener('change', this.handleVariantChange.bind(this));
    });
  }

  handleVariantChange(event) {
    const radio = event.currentTarget;
    if (!radio.checked) return;
    
    const mediaId = radio.dataset.mediaId;
    const variantId = radio.dataset.variantId;
    
    // Find the slide with this media
    const slides = this.slideshow?.querySelectorAll('slideshow-slide');
    let targetSlide = null;
    let targetIndex = -1;
    
    slides?.forEach((slide, index) => {
      const slideMedia = slide.querySelector('[data-media-id]');
      if (slideMedia && slideMedia.dataset.mediaId === mediaId) {
        targetSlide = slide;
        targetIndex = index;
      }
    });
    
    // Transition to the target slide using the select method
    if (targetSlide && this.slideshow) {
      // The slideshow expects either an index number or an object with slide id
      if (typeof this.slideshow.select === 'function') {
        // Get the slide-id attribute if it exists
        const slideId = targetSlide.getAttribute('slide-id');
        if (slideId) {
          // Use slide ID for selection
          this.slideshow.select({ id: slideId }, undefined, { animate: true });
        } else {
          // Use index for selection
          this.slideshow.select(targetIndex, undefined, { animate: true });
        }
      }
    }
    
    // Optionally update the URL with the variant
    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
  }
}

// Define the custom element
if (!customElements.get('media-gallery-variant-selector')) {
  customElements.define('media-gallery-variant-selector', MediaGalleryVariantSelector);
}